// src/static/js/OutlineUtils.js
import * as turf from '@turf/turf';

/**
 * Строит внешний контур объединённой области по массиву гексагонов (GeoJSON Polygon features).
 * В отличие от edge-counting подхода, использует geometric union — устойчив к
 * микроскопическим расхождениям координат общих вершин соседних ячеек.
 */
export function computeOutlineFeatures(hexagons) {
    if (!hexagons?.length) return [];

    const polys = hexagons
        .filter(f => f?.geometry?.type === 'Polygon' || f?.geometry?.type === 'MultiPolygon')
        .map(f => turf.feature(f.geometry));

    if (polys.length === 0) return [];
    if (polys.length === 1) return ringsToLines(polys[0].geometry);

    let merged = polys[0];
    for (let i = 1; i < polys.length; i++) {
        try {
            merged = unionTwo(merged, polys[i]) || merged;
        } catch (e) {
            console.warn('[OutlineUtils] union failed on feature', i, e);
        }
    }

    return ringsToLines(merged.geometry);
}

/** Совместимость с разными версиями @turf/turf: v6 — union(a, b), v7 — union(featureCollection([a,b])) */
function unionTwo(a, b) {
    try {
        // turf v7+
        return turf.union(turf.featureCollection([a, b]));
    } catch (e) {
        // turf v6 и ниже
        return turf.union(a, b);
    }
}

function ringsToLines(geometry) {
    const lines = [];
    const polygons = geometry.type === 'Polygon' ? [geometry.coordinates] : geometry.coordinates;

    polygons.forEach(rings => {
        rings.forEach(ring => {
            lines.push({
                type: 'Feature',
                geometry: { type: 'LineString', coordinates: ring },
                properties: {}
            });
        });
    });

    return lines;
}